import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig"
import { useEffect } from "react"
import {
  startObservingConsentStatusChange,
  updateConsentStatus,
  updateDeviceIdPersistenceConsent,
} from "@theconversation/shared-libraries/tcEventsCollector"
import { isEnabled } from "../Didomi"
import { setDidomiEnabledStatus } from "@theconversation/shared-libraries/Didomi"

/*
  Consent status tracking:
  - fetch initial value, as user may have consented on a previous visit.
  - monitor for consent status changing on this visit, as this occurs when
    the user clicks the buttons presented on the consent pop-up dialog.
 */
export const GdprConsentStatus = () => {
  const regionConfig = useRegionConfig()

  useEffect(() => {
    // If Didomi isn't even enabled, default to true
    if (!isEnabled(regionConfig)) {
      updateDeviceIdPersistenceConsent(true)
      setDidomiEnabledStatus(false)
    } else {
      updateConsentStatus()
      startObservingConsentStatusChange()
    }
  }, [regionConfig])

  return <></>
}
